import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { ChangePassword } from './pages/ChangePassword';
import { Resumo } from './pages/Resumo';
import { Dashboard } from './pages/Dashboard';
import { Equipe } from './pages/Equipe';
import { Etapas } from './pages/Etapas';
import { CupIcon } from './components/CupIcon';
import { Produto } from './pages/Produto';
import { Capa } from './pages/Capa';
import { Tarefas } from './pages/Tarefas';
import { Atrasos } from './pages/Atrasos';
import { Reunioes } from './pages/Reunioes';
import { OutrosAssuntos } from './pages/OutrosAssuntos';
import { Cancelados } from './pages/Cancelados';
import { SaidaLinha } from './pages/SaidaLinha';
import { SaidaLinhaProduto } from './pages/SaidaLinhaProduto';
import { Rampa } from './pages/Rampa';
import { RampaProduto } from './pages/RampaProduto';
import { Metodologia } from './pages/Metodologia';
import { Usuarios } from './pages/Usuarios';
import { Adesao } from './pages/Adesao';
import { UsageTracker } from './components/UsageTracker';

export default function App() {
  const { loading, session, orgs, mustChangePassword } = useAuth();

  if (loading) return <div className="center-note">Carregando…</div>;
  if (!session) return <Login />;
  if (mustChangePassword) return <ChangePassword />;

  if (orgs.length === 0) return <NoOrg />;

  return (
    <BrowserRouter>
      <UsageTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Resumo />} />
          <Route path="/executivo" element={<Dashboard />} />
          <Route path="/equipe" element={<Equipe />} />
          <Route path="/etapas" element={<Etapas />} />
          <Route path="/produto/:id" element={<Produto />} />
          <Route path="/produto/:id/capa" element={<Capa />} />
          <Route path="/tarefas" element={<Tarefas />} />
          <Route path="/atrasos" element={<Atrasos />} />
          <Route path="/reunioes" element={<Reunioes />} />
          <Route path="/outros-assuntos" element={<OutrosAssuntos />} />
          <Route path="/cancelados" element={<Cancelados />} />
          <Route path="/saida-linha" element={<SaidaLinha />} />
          <Route path="/saida-linha/:id" element={<SaidaLinhaProduto />} />
          <Route path="/rampa" element={<Rampa />} />
          <Route path="/rampa/:id" element={<RampaProduto />} />
          <Route path="/usuarios" element={<Usuarios />} />
          <Route path="/adesao" element={<Adesao />} />
          <Route path="/metodologia" element={<Metodologia />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function NoOrg() {
  const { email, signOut } = useAuth();
  return (
    <div className="login-wrap">
      <div className="card card-pad login-card" style={{ textAlign: 'center' }}>
        <div className="mark" style={{ margin: '0 auto 14px' }}>
          <CupIcon size={22} />
        </div>
        <h1 style={{ fontSize: 18 }}>Sua conta ainda não está vinculada</h1>
        <p className="muted" style={{ margin: '10px 0 18px' }}>
          {email}, você entrou, mas ainda não faz parte de nenhuma organização. Peça a um
          administrador para incluir seu acesso.
        </p>
        <button className="btn-ghost" onClick={() => signOut()}>
          Sair
        </button>
      </div>
    </div>
  );
}
